import { OrientationType, ResolutionType, useScreenStore } from "application/contexts/screen/ScreenStore";
import { useTranslation } from "i18n/useTranslation";
import React, { FC, ReactNode } from "react";
import { Button } from "@material-ui/core";
import totemGif from "assets/images/totem.gif";
import styles from "../../../offlineRecharge/OfflineRecharge.module.scss";

/**
 * Layout compartilhado: leitura e gravação (etapa 1 e etapa 3).
 * Mensagem em duas linhas + gif do totem. Opcional: botão "Tentar novamente".
 */
export interface ApproximateCardLayoutProps {
  /** Primeira linha da mensagem */
  line1: ReactNode;
  /** Segunda linha da mensagem */
  line2: ReactNode;
  /** Exibe botão "Tentar novamente" (etapa de leitura com erro) */
  showRetryButton?: boolean;
  /** Callback ao clicar em "Tentar novamente" */
  onRetry?: () => void;
}

export const ApproximateCardLayout: FC<ApproximateCardLayoutProps> = ({
  line1,
  line2,
  showRetryButton = false,
  onRetry,
}) => {
  const { resolution, orientation } = useScreenStore();
  const { t } = useTranslation();
  const isLandscape = orientation === OrientationType.LANDSCAPE;
  const fontSize = resolution === ResolutionType.FULL_HD ? 70 : isLandscape ? 36 : 50;
  const margin = resolution === ResolutionType.FULL_HD ? 150 : isLandscape ? 24 : 75;
  const gifWidth = resolution === ResolutionType.FULL_HD ? 900 : isLandscape ? 300 : 500;
  const gifHeight = resolution === ResolutionType.FULL_HD ? 500 : isLandscape ? 180 : 300;
  const spacerHeight = resolution === ResolutionType.FULL_HD ? 200 : isLandscape ? 24 : 100;

  return (
    <div className={styles.approximateCardLayout}>
      <div>
        <div
          className={styles.readCardMessage}
          style={{ margin }}
        >
          <p style={{ fontSize }}>{line1}</p>
          <p style={{ fontSize }}>{line2}</p>
        </div>
        <div>
          <img
            className={styles.totemGif}
            src={totemGif}
            alt="totem"
            style={{ width: gifWidth, height: gifHeight }}
          />
        </div>
      </div>
      {showRetryButton && onRetry && (
        <div
          style={{
            padding: resolution === ResolutionType.FULL_HD ? 24 : 16,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={onRetry}
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
              padding:
                resolution === ResolutionType.FULL_HD
                  ? "16px 48px"
                  : "12px 32px",
            }}
          >
            {t("offline_recharge_v2.try_again")}
          </Button>
        </div>
      )}
      <div style={{ height: spacerHeight }} />
    </div>
  );
};
